import script from "./TabsHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./TabsHeader.vue?vue&type=script&lang=ts&setup=true"

import "./TabsHeader.vue?vue&type=style&index=0&id=3c35fdfd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c35fdfd"]])

export default __exports__